import { TourConfig, TourHandle, useFeatureTour } from '@app/core/tours/useFeatureTour';
import { useMemo } from 'react';
import { defineMessage, useIntl } from 'react-intl';

/**
 * Runs the one-time tour for the fragments list "Add filter" button if not yet seen and before expiry.
 * Highlights new filters: Content AI, external delivery, and published platforms.
 */
export function useFragmentsAddFilterTour(listId: string): TourHandle {
  const { $t } = useIntl();

  return useFeatureTour(
    { key: 'fragmentsListV3AddFilter', expiry: '2026-04-30' },
    useMemo<TourConfig>(
      () => ({
        steps: [
          {
            element: `#${listId}-add-filter-btn`,
            popover: {
              title: $t(
                defineMessage({
                  id: 'fragments.listV3.tour.addFilter.title',
                  defaultMessage: 'Nuevos filtros disponibles',
                }),
              ),
              description: $t(
                defineMessage({
                  id: 'fragments.listV3.tour.addFilter.description',
                  defaultMessage:
                    'Agrega filtros como Contenido AI, Export externo y Plataformas publicadas desde aquí para filtrar fragmentos.',
                }),
              ),
              side: 'bottom',
              align: 'start',
            },
          },
        ],
      }),
      [$t, listId],
    ),
  );
}
